export default [
  {
    component: () => import('./Error.vue'),
    children: [
      {
        name: 'ErrorNotFOund',
        path: '/not-found',
        component: () => import('./content/ErrorNotFound.vue'),
        meta: {
          title: 'Página não encontrada',
        },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/not-found',
  },
];
